import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {DocumentService} from '../../../shared/services/document.service';
import {Document} from '../../../shared/interface/document';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {DocumentPreviewComponent} from "../../../shared/components/document-preview/document-preview.component";

@Component({
  selector: 'app-document-list',
  templateUrl: './document-list.component.html',
  styleUrls: ['./document-list.component.scss']
})
export class DocumentListComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() documents: Observable<Document[]>;
  @Input() excludeColumns: string[] = [];
  @Output() changed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  documentDataSource: MatTableDataSource<Document> = new MatTableDataSource<Document>([]);
  displayedColumns: string[] = ['name', 'type', 'deviceProtocolDate', 'createdAt', 'updatedAt', 'user',
    'partnerOrOfwca', 'contractType', 'insuranceCompany', 'actions'];
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private documentService: DocumentService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngOnInit(): void {
    this.documents
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((documents: Document[]) => this.documentDataSource.data = documents);

    this.displayedColumns = this.displayedColumns.filter((e: string) => {
      return this.excludeColumns.indexOf(e) === -1;
    });
  }

  ngAfterViewInit(): void {
    this.documentDataSource.paginator = this.paginator;
  }

  downloadFile(uuid: string): void {
    this.documentService.downloadFile(uuid);
  }

  deleteDocument(document: Document): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć dokument?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.documentService.deleteDocument(document.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto dokument', '', {duration: 2000});
            this.changed.emit(true);
          });
      }
    });
  }
  openDocument(document: Document): void {
    const dialogRef = this.dialog.open(DocumentPreviewComponent, {
      maxWidth: '70vw',
      minWidth: '50vw',
      maxHeight: '90vh',
      autoFocus: false,
      data: {document: document},
    });
  }
}
